<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div class="mx-4">
    <PinItem v-if="actionValue.type === 'promote'" :action="actionValue" />
    <HideItem v-if="actionValue.type === 'hide'" :action="actionValue" />
    <PromoteCategory v-if="actionValue.type === 'promCategory'" :action="actionValue" />
    <ChangeSortCriterion v-if="actionValue.type === 'changeSortCriterion'" :action="actionValue" />
    <Redirection v-if="actionValue.type === 'redirection'" :workspaces="workspaces" :action="actionValue" />
    <ApplyFilter v-if="actionValue.type === 'applyFilter'" :action="actionValue" :index="index" />
    <DisplayContent v-if="actionValue.type === 'displayContent'" :action.sync="actionValue" :actions-module-configuration="actionsModuleConfiguration" />
    <SEOMetaTags v-if="actionValue.type === 'seoMetaTags'" :action.sync="actionValue" />
    <RobotsIndex v-if="actionValue.type === 'robotsIndex'" :action.sync="actionValue" />
    <TitleOverwrite v-if="actionValue.type === 'titleOverwrite'" :action="actionValue" />

    <CodeEditorJSON v-if="actionValue.type === 'customJSON'" v-model="actionValue.json" />
    <CodeEditorHTML v-if="actionValue.type === 'customHTML'" v-model="actionValue.html" />
  </div>
</template>

<script setup>

import { ref, watch, defineEmits } from 'vue';

import PinItem from './ActionFormFields/PinItem.vue';
import HideItem from './ActionFormFields/HideItem.vue';
import PromoteCategory from './ActionFormFields/PromoteCategory.vue';
import ChangeSortCriterion from './ActionFormFields/ChangeSortCriterion.vue';
import Redirection from './ActionFormFields/Redirection.vue';
import ApplyFilter from './ActionFormFields/ApplyFilter.vue';
import DisplayContent from './ActionFormFields/DisplayContent.vue';
import SEOMetaTags from './ActionFormFields/SEOMetaTags.vue';
import RobotsIndex from './ActionFormFields/RobotsIndex.vue';
import TitleOverwrite from './ActionFormFields/TitleOverwrite.vue';

import CodeEditorJSON from '../../CodeEditorJSON.vue';
import CodeEditorHTML from '../../CodeEditorHTML.vue';

const props = defineProps({
  action: { type: Object, required: true },
  workspaces: { type: Array, default: null },
  index: { type: Number, required: true },
  actionsModuleConfiguration: { type: Object, default: null }
});

const actionValue = ref(props.action);

const emit = defineEmits(['update:action']);

watch(() => actionValue.value, val => {
  emit('update:action', val);
}, { deep: true });

</script>

<style>
</style>
